/* eslint-disable no-inner-declarations */
/* eslint-disable no-plusplus */
import React from 'react'

let timer = null
let width = 10
const Index = ({ timeout }) => {

  React.useEffect(() => {
    const elem = document.getElementById("myBar_loading");
    timer = setInterval(() => {
      if (width >= 95) {
        clearInterval(timer);
        timer = null
      } else {
        width++;
        elem.style.width = `${width}%`;
      }
    }, timeout || 100);

  }, [])

  return (
    <div className="meter animate">
      <span id="myBar_loading" style={{ width: '1%' }}><span /></span>
    </div>
  )
}

export default Index